export const tabData = [
  {
    label: "Compliance monitor",
    to: "/compliance/monitor",
    "data-test": "compliance-monitor-tab",
  },
];

export default tabData;
